import axios from "axios";
import axiosInstance from "./api_helper";
import config from "../helpers/config";

const API_URL = "/api/companies";

const buildCompanyFormData = ({ company, logo }) => {
    const formData = new FormData();
    formData.append("company", JSON.stringify(company));

    if (logo) {
        formData.append("logo", logo);
    }

    return formData;
};

const companyService = {
    create: async ({ company, logo }) => {
        const formData = buildCompanyFormData({ company, logo });

        return axios.post(`${config.baseURL}${API_URL}`, formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
    },

    update: async ({ company, logo }) => {
        const formData = buildCompanyFormData({ company, logo });

        return axios.put(`${config.baseURL}${API_URL}`, formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
    },

    delete: async (id) => {
        return axiosInstance.delete(`${API_URL}/${id}`);
    },

    getById: async (id) => {
        return axiosInstance.get(`${API_URL}/${id}`);
    },

    getAll: async () => {
        return axiosInstance.get(API_URL);
    },
};

export default companyService;
